<div class="prepare-container">
  <div class="left-panel">
    <h1>List of decisions</h1>
    <h2>
      Pizza ipsum dolor meat lovers buffalo. Red and roll onions pizza party and
      Hawaiian. Deep white.
    </h2>
    <!-- LIST OF DECISIONS -->
    <div class="decision-list">
      <mat-radio-group
        [(ngModel)]="selectedDecision"
        (change)="onDecisionChange($event)"
      >
        <mat-radio-button
          class="radio-button"
          *ngFor="let decision of decisionList"
          [value]="decision"
        >
          <div class="decision">
            <div class="column-direction">
              <label for="nameDecision" class="decision-name">{{
                decision.name
              }}</label>
              <div>
                <label for="impactOrganization" class="impact">Impact </label>
                <span class="allOrganization">All the organization</span>
              </div>
            </div>
            <div class="column-direction">
              <div style="width: max-content">
                <label for="implementation" class="impact"
                  >Implementation:</label
                >
                <span class="allOrganization">
                  {{ decision.implementation_weeks }} Weeks</span
                >
              </div>
              <div>
                <label for="weeks" class="impact">Until reuse</label>
                <span class="allOrganization">
                  {{ decision.weeks_until_reuse }} Weeks</span
                >
              </div>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="button-container">
      <button class="btn" (click)="clearOrgChart()">Clear</button>
      <button class="btn" (click)="takeAction()">Take Action</button>
    </div>
  </div>

  <div class="right-panel">
    <!-- ORGANIZATION CHART -->
    <div
      class="organization-chart"
      [ngClass]="{ 'organization-chart-disabled': selectedDecision == null }"
    >
      <div class="org-chart-titles">
        <h1 class="mediumTitle">Organization chart</h1>
        <div>
          <h2>Selected Staff</h2>
          <h2>{{ selectedStaffCount }} / 20</h2>
        </div>
      </div>
      <div class="chart-conatiner">
        <div [style.transform]="'scale(' + zoom + ')'" style="display: flex">
          <ngx-org-chart
            [nodes]="nodes"
            direction="vertical"
            (itemClick)="itemClick($event)"
          ></ngx-org-chart>
        </div>
      </div>
      <div class="zoom-button-container">
        <button class="btn" (click)="zoomOrganizationChart(-0.1)">-</button>
        <button class="btn" (click)="zoomOrganizationChart(+0.1)">+</button>
      </div>
    </div>

    <br />

    <!-- ADOPTION STAGE OF THE ORGANIZATION -->
    <div class="adoption-stage">
      <h1 class="mediumTitle">Adoption stage of the organization</h1>
      <div class="stepper-wrapper">
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[0] }">
          <div class="step-counter">1</div>
          <div class="step-name">Mobilization</div>
        </div>
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[1] }">
          <div class="step-counter">2</div>
          <div class="step-name">Movement</div>
        </div>
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[2] }">
          <div class="step-counter">3</div>
          <div class="step-name">Support</div>
        </div>
      </div>
    </div>

    <br />

    <div class="decision-details-container">
      <!-- Credibility -->
      <div class="credibility mr">
        <h1>Credibility</h1>

        <div class="progress">
          @for (bar of progressBars; track $index;) {
          <div
            class="progressBar"
            [ngClass]="{ 'pink-bar': $index < credibility }"
          ></div>
          }
        </div>
        <label for="rating">{{ credibility }} of 10</label>
      </div>

      <!-- USEFUL WEEKS -->
      <div class="usefulWeeks mr">
        <h1>Useful Weeks</h1>

        <div class="semi-circle-container">
          <svg class="semi-circle" viewBox="0 0 100 50">
            <path class="background" d="M 10 50 A 40 40 0 1 1 90 50" />
            <path
              class="progress"
              d="M 10 50 A 40 40 0 1 1 90 50"
              [attr.stroke-dasharray]="dashArray"
              [attr.stroke-dashoffset]="dashOffset"
            />
          </svg>
          <div class="progress-text">
            <span>{{ weeksProgress }} of {{ maxWeeks }}</span>
            <div>weeks</div>
          </div>
        </div>
      </div>

      <!-- CRITICAL MASS -->
      <div class="criticalMass">
        <h1>Critical mass</h1>

        <div class="progress">
          <div
            *ngFor="let bar of progressCriticalMass; let i = index"
            class="progress-wrapper"
          >
            <!-- Tooltip container -->
            <div class="tooltip-container" *ngIf="i === 18">
              <div class="tooltip-text">Critical mass</div>
              <div class="colita"></div>
            </div>

            <!-- Progress bar -->
            <div
              class="progressBar"
              [ngClass]="{
                'yellow-bar': i === 18,
                'pink-bar': i < criticalMass
              }"
            ></div>
          </div>
        </div>
        <label for="rating">{{ criticalMass }} of 20</label>
      </div>
    </div>
  </div>
</div>
